module.exports = __webpack_public_path__ + "img/pic4.6a0f83a9.png";